import React from 'react';
import { CustomerAddressesRequirementOptions } from "../../common/UICustomerFilter";
import AttributeFilterComponent from './AttributeFilterComponent';
import {
    Select,
    Stack,
} from '@shopify/polaris';

class CustomerAddressesFilter extends React.Component {

    render() {
        var filter = this.props.itemsFilter;
        var filterComponent = <AttributeFilterComponent
            attributeIsOptional={filter.attributeIsOptional}
            attributeType={filter.attributeType}
            distinctValues={[]}
            onRequestAttributeValues={() => { }}
            onConditionOperatorChange={this.props.onConditionOperatorChange}
            onConditionValueChange={this.props.onConditionValueChange}
            conditionType={filter.body.conditionType}
            conditionOperator={filter.body.conditionOperator}
            conditionValue={filter.body.conditionValue} />

        return <Stack alignment="center" spacing="tight">
            <Select
                options={CustomerAddressesRequirementOptions}
                value={this.props.requirement}
                onChange={(selected) => this.props.onRequirementChange(selected)}
            />
            {filterComponent}
        </Stack>
    }
}

CustomerAddressesFilter.defaultProps = {
    itemsFilter: null
}

export default CustomerAddressesFilter;